import { FC } from 'react';
import { FormikProps } from 'formik';

import { MASK_PHONE, PREFIX_MOB_PHONE } from 'const';
import { InputFieldForm } from '../InputFieldForm';
import { ITextField } from 'core/components/forms/TextField/TextField';

import './style.scss';

interface IPhoneFieldFormProps {
  formikProps: FormikProps<any>;
}

export const PhoneFieldForm: FC<IPhoneFieldFormProps & ITextField> = (props) => {
  const { formikProps, ...rest } = props;

  return (
    <InputFieldForm
      {...rest}
      formikProps={formikProps}
      inputMode="tel"
      children={<span className="prefix-phone">{PREFIX_MOB_PHONE}</span>}
      maskedProps={{
        ...MASK_PHONE,
      }}
      classNames={{ root: 'input-box-phone' }}
    />
  );
};
